<div class="socketio-audit-page" testId="socketio-audit-page">
  <section class="socketio-audit-frame-shell" testId="socketio-audit-frame-shell">
    <div class="socketio-audit-toolbar">
      <div class="socketio-audit-frame-meta">
        <span class="socketio-audit-frame-label">{{ 'route.socketio-connection-audit' | i18n }}</span>
        <span class="socketio-audit-frame-url">{{ iframeUrl }}</span>
      </div>
      <button nz-button nzType="default" type="button" (click)="openInNewWindow()" testId="socketio-audit-open-new-window">
        {{ 'socketio.audit.open-new-window' | i18n }}
      </button>
    </div>

    <iframe
      *ngIf="safeIframeUrl"
      class="socketio-audit-frame"
      [src]="safeIframeUrl"
      [attr.title]="'route.socketio-connection-audit' | i18n"
      referrerpolicy="no-referrer-when-downgrade"
      testId="socketio-audit-iframe"
    ></iframe>
  </section>
</div>
